<div>
    <price-checker #priceChecker [hideFeeAndTaxGeneralBreakdown]="isCsr" [hideTooltips]="isCsr"></price-checker>
</div>
